import { render, staticRenderFns } from "./option1.vue?vue&type=template&id=6730d1f1&scoped=true&"
import script from "./option1.vue?vue&type=script&lang=js&"
export * from "./option1.vue?vue&type=script&lang=js&"
import style0 from "./option1.vue?vue&type=style&index=0&id=6730d1f1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6730d1f1",
  null
  
)

export default component.exports